export default "__VITE_ASSET__CfV8cnN8__"